import { useTranslation } from '@/lib/i18n/i18n.client';

import { BlockComponentModel } from '@/cms/types/blok-component';

import Avatar from '@/decodo/components/atoms/Avatar';
import RichTextFieldStrapi from '@/decodo/components/atoms/RichTextField/RichTextFieldStrapi';
import { Text } from '@/decodo/components/atoms/Text';
import AuthorItem from '@/decodo/components/organisms/author/AuthorItem';
import { AuthorStrapiProps } from '@/decodo/components/organisms/author/AuthorStrapi';

export const BlogAuthor = ({
  block,
}: BlockComponentModel<AuthorStrapiProps>) => {
  const { blogAuthor } = block;
  const { texts } = useTranslation();

  return (
    <div data-tracker-section='blog-author'>
      <Text className='text-h3 pb-8 font-serif md:pb-6'>
        {texts.author.about_author}
      </Text>
      <AuthorItem
        authorPageSlug={blogAuthor.data?.attributes.authorPageSlug}
        image={
          <Avatar
            src={
              blogAuthor.data?.attributes?.image?.image?.data?.attributes
                ?.url || ''
            }
            alt={
              blogAuthor.data?.attributes?.image?.image?.data?.attributes
                ?.alternativeText || ''
            }
          />
        }
        name={blogAuthor.data?.attributes?.name}
        title={blogAuthor.data?.attributes?.title}
        bio={<RichTextFieldStrapi block={blogAuthor?.data?.attributes?.bio} />}
      />
      <Text className='text-body-s pt-8 text-gray-500 sm:pt-12'>
        {texts.author.disclaimer}
      </Text>
    </div>
  );
};
